import { render, staticRenderFns } from "./PutInConfig.vue?vue&type=template&id=6a505906&scoped=true"
import script from "./PutInConfig.vue?vue&type=script&lang=js"
export * from "./PutInConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a505906",
  null
  
)

export default component.exports